import { createReducer, on, Action } from '@ngrx/store';
import * as contactsActions from '../actions/contacts.actions';
import { ContactApiModel } from 'app/models/contact-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

export interface State {
  contacts: MwPayloadModel<ContactApiModel[]>;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  contacts: { results: [], count: 0 },
  isLoading: false,
  isReady: false,
  isSaving: false,
};

export const featureReducer = createReducer(
  initialState,
  on(contactsActions.loadContacts, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(contactsActions.loadContactsSuccess, (state: State, { response }) => {
    let results = (response as MwPayloadModel<ContactApiModel[]>).results;
    let count = 0;
    if (results) {
      count = (response as MwPayloadModel<ContactApiModel[]>).count;
    } else {
      results = response as ContactApiModel[];
      count = results.length;
    }

    return {
      ...state,
      isLoading: false,
      isReady: true,
      contacts: {
        results,
        count,
      },
    };
  }),
  on(contactsActions.createContact, contactsActions.updateContact, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    contactsActions.createContactSuccess,
    contactsActions.createContactFailed,
    contactsActions.updateContactSuccess,
    contactsActions.updateContactFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
